import { AgGridReact } from 'ag-grid-react';

/**
 * Default grid refresh for the refresh icon in the ComposedViewAgGrid.
 */
const refreshGrid = (grid: AgGridReact) => grid.api.redrawRows();

export default refreshGrid;
